// extracted by mini-css-extract-plugin
export default {"container":"product_container__z6TQJ","info":"product_info__PunVw","values-wrapper":"product_values-wrapper__ahdp1","quantity":"product_quantity__peHUC"};